import { Set, OrderedMap } from 'immutable';

const displayName = (field) => {
  switch (field) {
    case 'cvv':
      return 'CVV';
    case 'expirationMonth':
      return 'expiration month';
    case 'expirationYear':
      return 'expiration year';
    case 'number':
      return 'credit card number';
    case 'postalCode':
      return 'zip code';
    default:
      return field;
  }
};

export const HANDLE_PAYMENT_ERROR = 'handle-payment-error';
const handlePaymentError = (fieldErrors) => {
  let errorFields = Set();
  if (fieldErrors && fieldErrors.map) { errorFields = Set(fieldErrors.map(e => e.field)); }
  if (errorFields.get('billingAddress')) {
    errorFields = errorFields.delete('billingAddress').add('postalCode');
  }

  let requiredFieldErrors = OrderedMap();
  errorFields.forEach((field) => {
    requiredFieldErrors = requiredFieldErrors.set(field, {
      isValid: false,
      isPotentiallyValid: false,
      isEmpty: false,
      displayName: displayName(field),
    });
  });

  return {
    type: HANDLE_PAYMENT_ERROR,
    payload: { requiredFieldErrors },
  };
};
export default handlePaymentError;
